import { saveUserProfile } from "@/services/api/User";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import useAuth from "./auth";

export const useUserProfileForm = ({
  onSuccessCallback,
  onErrorCallback,
} = {}) => {
  const { user } = useAuth({ middleware: "auth" });
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [role, setRole] = useState("");
  const [country, setCountry] = useState("");
  const [industry, setIndustry] = useState("");
  const [isUpdating, setUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setIsLoading(true)
      setTimeout(() => {
        setIsLoading(false)
        if (!firstName) setFirstName(user.first_name);
        if (!lastName) setLastName(user.last_name);
        if (!email) setEmail(user.email);
        if (!companyName) setCompanyName(user.company_name);
        if (!jobTitle) setJobTitle(user.job_title);
        if (!role) setRole(user.role);
        if (!industry) setIndustry(user.industry);
        if (!country) setCountry(user.country);
        console.log('fire')
      }, 500)
    }
  }, [user]);

  const updateProfile = async () => {
    setUpdating(true);

    try {
      const payload = {
        first_name: firstName,
        last_name: lastName,
        email,
        company_name: companyName,
        job_title: jobTitle,
        role,
        industry,
        country,
      };

      if (!firstName) {
        return toast.error('First name is required!')
      }

      if (!companyName) {
        return toast.error('Company name is required!')
      }

      if (!jobTitle) {
        return toast.error('Job title is required!')
      }

      if (!role) {
        return toast.error('Role is required!')
      }

      if (!industry) {
        return toast.error('Industry is required!')
      }

      if (!country) {
        return toast.error('Country is required!')
      }

      const response = await saveUserProfile(payload);
      if (onSuccessCallback) {
        onSuccessCallback(response.data);
      }
    } catch (error) {
      toast.error("Error on update profile. Please try again!");
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    } finally {
      setUpdating(false);
    }
  };

  return {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    companyName,
    setCompanyName,
    jobTitle,
    setJobTitle,
    role,
    setRole,
    country,
    setCountry,
    industry,
    setIndustry,

    updateProfile,
    isUpdating,
    isLoading
  };
};
